class VideoPlayer extends HTMLElement {
  connectedCallback() {
    this.videoPlayButtons.forEach((button) => {
      button.addEventListener('click', this.playVideo.bind(this))
    })

    this.posterVideoTriggers.forEach((button) => {
      button.addEventListener('click', this.triggerPosterVideo.bind(this))
    })

    this.posterVideo?.addEventListener('video::playing', () => {
      this.posterVideoTriggers.forEach((button) =>
        button.classList.remove('playing')
      )
    })

    this.posterVideo?.addEventListener('video::disable-autoplay', () => {
      this.updateVideoNoAutoplay()
    })

    this.mobileMediaQuery = window.matchMedia('(max-width: 768px)')
    this.mainVideo?.addEventListener('video::init', () => {
      this.handleMediaQueryChange(this.mobileMediaQuery)
    })
    this.mobileMediaQuery.addEventListener('change', () =>
      this.handleMediaQueryChange(this.mobileMediaQuery)
    )
  }

  triggerPosterVideo(event) {
    if (!this.posterVideo) return

    const currentButton = event.currentTarget
    currentButton.classList.toggle('playing')

    if (currentButton.classList.contains('playing')) {
      this.posterVideo._pauseVideo()
    } else {
      this.posterVideo._playVideo()
    }
  }

  playVideo() {
    if (!this.mainVideo) return

    const type = this.mainVideo.getAttribute('data-type')

    switch (type) {
      case 'external_video':
        this.mainVideo.playExternalVideo()
        break
      case 'video':
        this.mainVideo._playVideo()
        break
      default:
        break
    }

    this.classList.add('playing')
  }

  updateVideoNoAutoplay() {
    const button = this.querySelector('.js-poster-trigger')
    button.classList.add('playing')
  }

  handleMediaQueryChange = (mobileMediaQuery) => {
    this.mainVideoElement.toggleAttribute(
      'playsinline',
      !mobileMediaQuery.matches
    )
  }

  get videoPlayButtons() {
    return this.querySelectorAll('.js-video-play')
  }

  get mainVideo() {
    return this.querySelector('.js-video-element')
  }

  get mainVideoElement() {
    return this.mainVideo.shadowRoot.querySelector('video')
  }

  get posterVideo() {
    return this.querySelector('.js-poster-video')
  }

  get posterVideoTriggers() {
    return this.querySelectorAll('.js-poster-trigger')
  }
}

customElements.define('video-player', VideoPlayer)
